import "./style.css";

export default function List(props) {
	function viewVideo() {
		props.setLink(props.link);
	}

	return (
		<>
			<div className="col-5 list-card">
				<div className="row ">
					<div className="d-flex align-items-center justify-content-center col-4">
						{/* <img className="img-fluid rounded" src={props.url_foto} alt="Produto" /> */}
						<img className="img-fluid rounded" src={props.url_foto} alt="imagem" />
					</div>

					<div className="col-8">
						<div className="list-description">
							<div className="d-flex justify-content-between align-itens-center">
								<small>
									<b> {props.titulo} </b>
								</small>
							</div>
							<div className="d-flex justify-content-between align-itens-center">
								<small className="d-block list-text">{props.assunto}</small>
							</div>
						</div>
						<div className="d-flex">
							<button className="btn btn-sm btn-outline-primary mt-4" onClick={(e) => viewVideo()}>
								Exibir Vídeo
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
{
	/* <>
<div className="col-5 container-listview listview">
	<div className="row p-3 ps-0 border-bottom list-content">
		<div className="col-3">

			<img className="img-fluid rounded" src="" alt="imagem" />
		</div>

		<div className="col-9">
			<div className="list-description">
				<div className="d-flex justify-content-between align-itens-center">
					<small>
						<b> {props.titulo} </b>
					</small>
				</div>
				<div className="d-flex justify-content-between align-itens-center">
					<small className="d-block list-text">{props.assunto}</small>
				</div>
			</div>
			<div className="d-flex">
				<button className="btn btn-sm btn-outline-primary mt-4" onClick={(e) => viewVideo()}>
					Exibir Vídeo
				</button>
			</div>
		</div>
	</div>
</div>
</>
);
} */
}
